var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('ActionBar'),_c('div',{class:[("" + (_vm.isFailed || !_vm.items.length
        ? 'page__content--no-items'
        : 'page__content')), {
      'page__content--from-v4': _vm.noMainMenuFromV4
    }]},[_c('Filters',{attrs:{"status":_vm.currentStatus},on:{"change":_vm.updateFilters}}),_c('Table',{attrs:{"items":_vm.itemsGroupByDate,"pagination":_vm.pagination,"status":_vm.currentStatus},on:{"reloadData":_vm.reloadData,"goToPage":_vm.updatePage}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }